module.exports = __webpack_public_path__ + "img/ai.539fef65.svg";